export const SPARTAN_SCROLL_TO_SECTION_OFFSET_PX = 0;
export const SPARTAN_SCROLL_TO_SECTION_DELAY_MS = 400;
